import {
	TTableStructure,
	ETableStructureType,
	ETableStructureAlign,
} from 'services/constants/tableStructureTypes';
import { TEudrUploadedFile } from 'redux/reducers/eudr/types';
import { EIconButtons } from 'services/constants/iconsTypes';

export const eudrFilesTableStructure: TTableStructure<keyof TEudrUploadedFile>[] = [
	{
		name: 'File Name',
		selector: 'fileName',
		show: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Uploaded At',
		selector: 'uploadedAt',
		show: true,
		sortable: true,
		filterable: true,

		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Uploaded By',
		selector: 'uploadedBy',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Comments',
		selector: 'comments',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Status',
		selector: 'fileStatus',
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			['Pending', 'Pending'],
			['Processed', 'Processed'],
			['Failed', 'Failed'],
		],
		colors: [
			['Pending', 'warning.light'],
			['Processed', 'success.light'],
			['Failed', 'error.light'],
		],

		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},

	{
		name: 'Actions',
		selector: 'id',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [{ name: 'Download', icon: EIconButtons.DOWNLOAD }],
		colSpan: 1,
		noName: true,
	},
];
